import { defineAction } from '~/prix'
import resienceListAction from './residenceList.action.json' with { type: 'json' }
import { residenceObject } from '../residenceObject'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import { residenceImageObject } from '../imageList/residenceImageList.definition'
import { latitude, longitude } from '~/prix/types/presets/geo'

export const residenceExpression = expression(residenceObject.shape)

const residenceListDefinition = defineAction({
  ...resienceListAction,

  input: z.object({
    filter: residenceExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      synchronizedAt: 'Data de sincronização',
      id: 'Identificador',
      title: 'Título',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(
      residenceObject.extend({
        plusCode: z.string().nullish(),
        latitude: latitude().nullish(),
        longitude: longitude().nullish(),
        images: z.array(
          residenceImageObject.omit({
            residenceId: true,
          }),
        ),
      }),
    ),
    count: z.number(),
  }),
})

export default residenceListDefinition
